// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ou8G","inner":"styles_inner__Ux_yI","right":"styles_right__1yTd2","close":"styles_close__3ex5o","footer":"styles_footer__1cmz6"};